import { Component, Input } from '@angular/core';
import { ViewablePlanningTreatmentDetail } from '../review-request.model';

@Component({
  selector: 'app-planning-treatment-detail',
  templateUrl: './planning-treatment-detail.component.html'
})
export class PlanningTreatmentDetailComponent {

  @Input() public treatmentDetail: ViewablePlanningTreatmentDetail;

  constructor() { }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/review-request/planning-treatment-detail/planning-treatment-detail.component.ts